/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UploadFileForReportCommandResult } from '../../models/upload-file-for-report-command-result';

export interface ApiProjectDailyTaskReportsUploadFileForReportPost$Params {
      body?: {
'ReportId'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectDailyTaskReportsUploadFileForReportPost(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsUploadFileForReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadFileForReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsUploadFileForReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UploadFileForReportCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsUploadFileForReportPost.PATH = '/api/ProjectDailyTaskReports/UploadFileForReport';
